import React from "react";
import type { ExtraNodeData, InterfaceToRecord } from "./action-config-node";
import ActionConfigNode from "./action-config-node";
import type { NodeProps, Node } from "@xyflow/react";

type SumNode = Node<InterfaceToRecord<ExtraNodeData>>;

export default function Sum(props: NodeProps<SumNode>): JSX.Element {
    return <ActionConfigNode nodeKind={props.type} {...props.data} />;
}
